// Setup error handling to suppress React error overlay for specific errors
// This file should be imported first in index.js

// Store reference to scenario-designer errors
window.__SCENARIO_EDITOR_ERROR__ = null;

// Intercept React DevTools error reporting
if (process.env.NODE_ENV === 'development') {
  // Override reportError to filter scenario-designer errors
  const setupErrorInterception = () => {
    // Try to find and patch the webpack error overlay
    if (window.__webpack_dev_server_client__) {
      const original = window.__webpack_dev_server_client__.sendMessage;
      if (original) {
        window.__webpack_dev_server_client__.sendMessage = function(type, data) {
          if (type === 'error' && data && JSON.stringify(data).includes('scenario-designer')) {
            console.error('[Scenario Editor Error - Overlay Suppressed]', data);
            window.__SCENARIO_EDITOR_ERROR__ = data;
            return;
          }
          return original.call(this, type, data);
        };
      }
    }

    // Also intercept the error event to prevent overlay
    window.addEventListener('error', function(event) {
      if (event.error && event.error.stack && event.error.stack.includes('scenario-designer')) {
        window.__SCENARIO_EDITOR_ERROR__ = event.error;
        event.stopImmediatePropagation();
        console.error('[Scenario Editor Error - Caught]', event.error);

        // Try to close any open overlays
        setTimeout(() => {
          const overlays = document.querySelectorAll('iframe[style*="position: fixed"]');
          overlays.forEach(overlay => {
            if (overlay.contentDocument || overlay.style.zIndex === '2147483647') {
              overlay.remove();
            }
          });
        }, 100);
      }
    }, true);
  };

  // Run setup immediately and also after a delay to catch late-loading modules
  setupErrorInterception();
  setTimeout(setupErrorInterception, 1000);
}

const errorHandlingConfig = {};
export default errorHandlingConfig;
